// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__2qlqX","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__2Kh8Q"};